import React from 'react';
import DummyPage from '../components/DummyPage';
import PageContainer from '../containers/PageContainer';

const AboutUsPage = () => {
  return (
    <PageContainer>
      <DummyPage title="About Us" />
    </PageContainer>
  );
};

export default AboutUsPage;
